var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.933594,
    width: 21,
    height: 26.1333,
    fill: "white",
    stroke: "#C8CACD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 9,
    height: 8,
    fill: "#C8CACD",
    stroke: "#C8CACD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 3.25,
    width: 4.5,
    height: 0.5,
    fill: "#C8CACD",
    stroke: "#C8CACD",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 5.25,
    width: 4.5,
    height: 0.5,
    fill: "#C8CACD",
    stroke: "#C8CACD",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 7.25,
    width: 4.5,
    height: 0.5,
    fill: "#C8CACD",
    stroke: "#C8CACD",
    strokeWidth: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 9.25,
    width: 4.5,
    height: 0.5,
    fill: "#C8CACD",
    stroke: "#C8CACD",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 11.25,
    width: 4.5,
    height: 0.5,
    fill: "#C8CACD",
    stroke: "#C8CACD",
    strokeWidth: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.075,
    y: 14.743,
    width: 15.85,
    height: 0.15,
    fill: "#C8CACD",
    stroke: "#C8CACD",
    strokeWidth: 0.15
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3.075,
    y: 16.0428,
    width: 15.85,
    height: 0.15,
    fill: "#C8CACD",
    stroke: "#C8CACD",
    strokeWidth: 0.15
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 3.075,
    y: 17.3426,
    width: 15.85,
    height: 0.15,
    fill: "#C8CACD",
    stroke: "#C8CACD",
    strokeWidth: 0.15
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3.075,
    y: 18.743,
    width: 15.85,
    height: 0.15,
    fill: "#C8CACD",
    stroke: "#C8CACD",
    strokeWidth: 0.15
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 3.075,
    y: 20.0428,
    width: 15.85,
    height: 0.15,
    fill: "#C8CACD",
    stroke: "#C8CACD",
    strokeWidth: 0.15
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 3.075,
    y: 21.3426,
    width: 15.85,
    height: 0.15,
    fill: "#C8CACD",
    stroke: "#C8CACD",
    strokeWidth: 0.15
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.3cccc1bef7bca4721af991fb59431e2f.svg";
export { ForwardRef as ReactComponent };